import { Card } from '@/components/ui/card';
import { motion } from 'framer-motion';
import { ExternalLinkIcon } from 'lucide-react';
import { ReactElement } from 'react';

interface BrandMention {
  id: string;
  title: string;
  url: string;
  date: string;
  emoji: string;
}

// Mock data - would normally come from an API
const MOCK_MENTIONS: BrandMention[] = [
  {
    id: '1',
    title: '@clue.labs is the best have you seen it!',
    url: '#',
    date: '2024-10-20',
    emoji: '😊',
  },
  {
    id: '2',
    title: '@inge.hunter have you had a look at @clue.labs that will help',
    url: '#',
    date: '2025-01-19',
    emoji: '🟰',
  },
  {
    id: '3',
    title: '@clue.labs is the worst',
    url: '#',
    date: '2024-08-18',
    emoji: '🛑',
  },
];

export const BrandMentionsCard = (): ReactElement => {
  const handleMentionClick = (url: string) => {
    window.open(url, '_blank');
  };

  const highlightMentions = (text: string) => {
    const parts = text.split(/(@[\w.]+)/g);

    return parts.map((part, index) => {
      if (part.startsWith('@')) {
        return (
          <span key={index} className="text-primary font-semibold">
            {part}
          </span>
        );
      }

      return part;
    });
  };

  return (
    <Card className="p-5 h-max w-full">
      <div className="flex flex-col gap-2">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h2 className="text-lg font-semibold">Brand Mentions</h2>
        </motion.div>

        <div className="space-y-6 flex flex-col">
          {MOCK_MENTIONS.map((mention) => (
            <div
              key={mention.id}
              className="flex items-start justify-between gap-4 cursor-pointer"
              onClick={() => handleMentionClick(mention.url)}>
              <div className="space-y-1">
                <span className="text-sm">
                  {mention.emoji} {new Date(mention.date).toLocaleDateString()}
                </span>
                <p className="font-medium line-clamp-2">
                  {highlightMentions(mention.title)}
                </p>
              </div>
              <ExternalLinkIcon className="w-4 h-4 shrink-0 text-muted-foreground" />
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};
